const toLocalIsoDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const todayIso = () => toLocalIsoDate(new Date());

export const startOfWeekIso = (date = new Date()) => {
  const copy = new Date(date);
  const day = copy.getDay();
  const diff = copy.getDate() - day + (day === 0 ? -6 : 1);
  copy.setDate(diff);
  return toLocalIsoDate(copy);
};

export const endOfWeekIso = (date = new Date()) => {
  const start = new Date(date);
  const day = start.getDay();
  const diff = start.getDate() - day + (day === 0 ? -6 : 1);
  start.setDate(diff + 6);
  return toLocalIsoDate(start);
};

export const startOfMonthIso = (date = new Date()) => toLocalIsoDate(new Date(date.getFullYear(), date.getMonth(), 1));

export const endOfMonthIso = (date = new Date()) => toLocalIsoDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));

export const formatDate = (value?: string) => {
  if (!value) return '';

  const isoDate = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) {
    const [, year, month, day] = isoDate;
    return `${day}.${month}.${year}`;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

export const formatHours = (hours: number | undefined) => `${(hours || 0).toFixed(2)}h`;

export const formatDurationMinutes = (minutes: number | undefined) => {
  const totalMinutes = Math.max(0, Math.round(minutes || 0));
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};

export const minutesToParts = (minutes: number) => ({
  hours: Math.floor(minutes / 60),
  minutes: minutes % 60,
});

export const partsToMinutes = (hours: number | '', minutes: number | '') => {
  const safeHours = hours === '' ? 0 : hours;
  const safeMinutes = minutes === '' ? 0 : minutes;
  return (Math.max(0, safeHours) * 60) + Math.max(0, safeMinutes);
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
